export function TopbarIcon({
  name,
}: {
  name: "gantt" | "event" | "task" | "cloud" | "bell";
}) {
  return (
    <svg
      className="topbar-action-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {name === "gantt" && (
        <>
          <path d="M4 3v17h17" />
          <rect
            x="7"
            y="5"
            width="10"
            height="3"
            rx="1.5"
            fill="currentColor"
            fillOpacity=".18"
          />
          <rect
            x="10"
            y="11"
            width="11"
            height="3"
            rx="1.5"
            fill="currentColor"
            fillOpacity=".18"
          />
          <path d="M8 17h6" />
        </>
      )}
      {name === "event" && (
        <>
          <path d="M14 21H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7M7 2v4m10-4v4M3 9h18" />
          <rect
            x="7"
            y="12"
            width="4"
            height="4"
            rx="1"
            fill="currentColor"
            fillOpacity=".18"
          />
          <path d="M18 15v6m-3-3h6" />
        </>
      )}
      {name === "task" && (
        <>
          <path d="M14 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7" />
          <path d="m8 9 2 2 5-5M8 15h4M18 15v6m-3-3h6" />
        </>
      )}
      {name === "cloud" && (
        <>
          <path
            d="M7 19h10a5 5 0 0 0 .5-10 6 6 0 0 0-11.6.5A4.8 4.8 0 0 0 7 19Z"
            fill="currentColor"
            fillOpacity=".12"
          />
          <path d="M9 12h6m-6 3h4" />
        </>
      )}
      {name === "bell" && (
        <>
          <path
            d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z"
            fill="currentColor"
            fillOpacity=".12"
          />
          <path d="M10 21h4M12 2V1" />
        </>
      )}
    </svg>
  );
}
